export default {
    fields: [
        {
            key: "_selected",
            label: "",
            sortable: false,
            filter: false,
            _filter: false,
            _style: "width:5%",
        },
        {
            key: "id",
            label: "#",
            sorter: false,
            active: true,
            filter: false,
            _filter: true,
            fixed: true,
            _style: "width:5%",
        },
        {
            key: "name",
            label: "name",
            sorter: true,
            filter: true,
            _filter: true,
            fixed: false,
            active: true
        },
        {
            key: "active",
            label: "active",
            sorter: true,
            filter: false,
            _filter: false,
            fixed: false,
            active: true
        },

        {
            key: "campaigns",
            label: "Campaigns",
            sorter: true,
            filter: false,
            _filter: false,
            fixed: false,
            _active: true,
        },
        
        {
            key: "shipment_balancing_type",
            label: "Shipment balancing type",
            sorter: true,
            filter: false,
            _filter: {
                active: false,
                value: null,
                condition: "is_equal_to",
                type: "select",
                options: [],
            },
            fixed: false,
            active: true
        },
        {
            key: "return_priority_response",
            label: "Return priority response",
            sorter: true,
            filter: false,
            _filter: false,
            fixed: false,
            active: true
        },
        {
            key: "created_at",
            label: "created_at",
            sorter: false,
            filter: false,
            _filter: false,
            _style: "width:10%",
            _type: "Date"
        },

    ],
    allFields: [],
    items: [],
    order: "desc",
    rows: 10,
    page: 1,
    total_pages: 0,
    loading: true,
    pagination: true,
    sorter: true,
    responsive: true,
    columnFilter: {
        external: true,
        lazy: true
    },
    columnFilterValue: {},
    itemsPerPageSelect: true,
    itemSelected: null
}
